<template>
  <div class="main">
    <div class="content" ref="containerRef">
      <div v-for="(value, key, index) in props.glossaryList" :key="index" :id="key">
        <GlossaryItem :letter="key" :children="value" :keyword="props.keyword" />
      </div>
    </div>
    <div class="anchor glossary-right-anchor">
      <el-anchor
        :container="containerRef"
        direction="vertical"
        type="default"
        :offset="30"
        @click="handleClick"
      >
        <el-anchor-link
          v-for="(value, key, index) in props.glossaryList"
          :key="index"
          :href="`#${key}`"
          :title="key"
        />
      </el-anchor>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

import GlossaryItem from '../GlossaryItem/index.vue';

const props = defineProps({
  glossaryList: {
    require: true,
    default: () => {},
  },
  keyword: {
    type: String,
    default: '',
  },
});

const containerRef = ref(null);

const handleClick = (e: MouseEvent) => {
  e.preventDefault();
};
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: space-between;
  .content {
    width: 94%;
    height: 7.5rem;
    overflow-y: auto;
  }

  .anchor {
    margin-left: 0px;
    margin-top: 0.3rem;
  }
}
</style>
<style lang="scss">
.glossary-right-anchor {
  .el-anchor {
    .el-anchor__marker {
      background-color: #0f5ef7;
    }
    .el-anchor__link {
      padding: 0;
    }
    .is-active {
      color: #0f5ef7;
    }
  }
}
</style>
